import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonMenuButton, IonModal, IonPage, IonRow, IonTextarea, IonTitle, IonToast, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { appsOutline, arrowBack, calendarOutline, chatbubbles, chatbubblesOutline, clipboardOutline, copy, desktopOutline, flagOutline, lockClosedOutline, notifications, tabletPortraitSharp, trendingUpOutline, warningOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Autoplay, Navigation, Pagination, Swiper as SwiperInterface } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import '@ionic/react/css/ionic-swiper.css';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import OnboardingHomeBanner from '../../../../../components/Onboarding/OnboardingHomeBanner';
import WelcomeModal from '../../../../../components/Onboarding/WelcomeModal';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import { getPlanos, onboardingBuscar, onboardingIniciar, pagamentoMensalidade, requestService, usuariosAlterarPin } from '../../../../../Utils/Services';
import Menu from '../../Components/Menu';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Inicio.css';
import PINInput from './PINInput';

type Props = {
  abrirMenu: boolean;
};

const Inicio: React.FC<Props> = (props: Props) => {
  const history = useHistory();
  const [showLoadingPage, setShowLoadingPage] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { mensagens, setMensagens } = useContext(MessageContext);
  const [swiperInstance, setSwiperInstance] = useState<SwiperInterface>();

  const [showModalPlanos, setShowModalPlanos] = useState(false);
  const [showModalAvisoPagamento, setShowModalAvisoPagamento] = useState(false);
  const [planos, setPlanos] = useState<any[]>([]);
  const [planoBase, setPlanoBase] = useState<any>(null);
  const [modulosDisponiveis, setModulosDisponiveis] = useState<any[]>([]);
  const [modulosSelecionados, setModulosSelecionados] = useState<string[]>([]);
  const [dadosEmpresaPlanos, setDadosEmpresaPlanos] = useState<any>(null);
  const [loadingPlanos, setLoadingPlanos] = useState(false);
  const [showModalQrCode, setShowModalQrCode] = useState(false);
  const [qrCodeData, setQRCodeData] = useState<any>();
  const [qrCode, setQRCode] = useState<any>();
  const { idPagamento, setIdPagamento } = useContext(MessageContext);
  const { isPaymentCompleted, setIsPaymentCompleted } = useContext(MessageContext);
  const [valorPagamento, setValorPagamento] = useState<any>();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const { onboardingData, setOnboardingData, onboardingCarregado, setOnboardingCarregado, setEtapaAtual } = useContext(OnboardingContext);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(6 * 60);
  const [showModalPin, setShowModalPin] = useState(false);
  const [pin, setPin] = useState(['', '', '', '']);
  const [confirmPin, setConfirmPin] = useState(['', '', '', '']);
  const [etapaPin, setEtapaPin] = useState(1);
  const [erroPin, setErroPin] = useState(false);
  const [pendingWelcomeModal, setPendingWelcomeModal] = useState(false);
  const tempoRestantePagamento = dadosEmpresa?.tempoRestanteParaPagamento;
  const diferencaDataPagamento = dadosEmpresa?.diferencaDataPagamento;
  const diasVencidosPagamento = diferencaDataPagamento !== null && diferencaDataPagamento !== undefined
    ? Number(diferencaDataPagamento)
    : Number.NaN;
  const diasRestantesPagamento = dadosEmpresa?.bloquearAcesso && Number.isFinite(diasVencidosPagamento)
    ? -Math.abs(diasVencidosPagamento)
    : tempoRestantePagamento !== null && tempoRestantePagamento !== undefined
      ? Number(tempoRestantePagamento)
      : Number.NaN;
  const deveExibirAvisoPagamento = Boolean(
    dadosEmpresa
    && Number.isFinite(diasRestantesPagamento)
    && diasRestantesPagamento <= 5
    && dadosEmpresa.pk === dadosEmpresa.gsi3pk
  );

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
    setNomeMenu("");
    setEtapaAtual(null);

    if (loja) {
      const url = onboardingBuscar.url.replace('{empresa_id}', encodeURIComponent(loja));
      requestService(url, { method: onboardingBuscar.method }, history,
        (response: any) => {
          setOnboardingCarregado(true);
          if (response.exists === false || !response.empresa_id) {
            const pinJaCadastrado = window.localStorage.getItem("pinCadastrado") === "true";
            if (pinJaCadastrado) {
              setShowWelcomeModal(true);
            } else {
              setPendingWelcomeModal(true);
            }
          } else {
            setOnboardingData(response);
          }
        },
        (error: any) => {
          console.log('Erro ao carregar onboarding:', error);
          setOnboardingCarregado(true);
        }
      );
    }

    const pinCadastrado = window.localStorage.getItem("pinCadastrado");
    if (pinCadastrado && pinCadastrado === "true") {
      console.log("PIN já cadastrado");
    } else {
      setShowModalPin(true);
    }

    if (deveExibirAvisoPagamento) {
      setShowModalAvisoPagamento(true);
    }
  });

  useEffect(() => {
    if (deveExibirAvisoPagamento) {
      setShowModalAvisoPagamento(true);
    }
  }, [deveExibirAvisoPagamento]);

  async function carregarPlanos() {
    setLoadingPlanos(true);
    try {
      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") { token = tkn; }
      let resp = await fetch(getPlanos.url, {
        method: getPlanos.method,
        headers: [["token", token]],
        credentials: 'include'
      });
      let retorno = await resp.json();
      if (resp.status === 200) {
        if (retorno.planoBase) {
          setPlanoBase(retorno.planoBase);
          const modulos = retorno.modulos || [];
          setModulosDisponiveis(modulos);
          setModulosSelecionados(modulos.map((m: any) => m.id));
          setDadosEmpresaPlanos(retorno.dadosEmpresa || null);
        }
        if (retorno.planos) { setPlanos(retorno.planos); }
      } else {
        setTextToast("Erro ao carregar planos. Tente novamente.");
        setShowToast(true);
      }
    } catch (error) {
      setTextToast("Erro ao carregar planos. Tente novamente.");
      setShowToast(true);
    } finally {
      setLoadingPlanos(false);
    }
  }

  async function abrirPlanosPagamento() {
    setShowModalAvisoPagamento(false);
    setShowModalPlanos(true);
    await carregarPlanos();
  }

  function gerarCompraCanonica(modulosSel: string[]): string {
    const temRobo = modulosSel.includes("robo_whatsapp_ia");
    const temFiscal = modulosSel.includes("modulo_fiscal");
    if (temRobo && temFiscal) return "mensalidade_robo_fiscal";
    if (temRobo) return "mensalidade_robo";
    if (temFiscal) return "mensalidade_fiscal";
    return "mensalidade";
  }

  function calcularTotalDinamico(modulosSel: string[]): number {
    if (!planoBase) return 0;
    const quantLojas = (dadosEmpresaPlanos && dadosEmpresaPlanos.quantidadeLojas) || 1;
    // planoBase.valor já vem do backend multiplicado por quantidadeLojas
    // Os módulos são valores unitários (por loja), então precisam ser multiplicados
    let total = planoBase.valor || 0;
    for (const modId of modulosSel) {
      const mod = modulosDisponiveis.find((m: any) => m.id === modId);
      if (mod) total += (mod.valor || 0) * quantLojas;
    }
    return parseFloat(total.toFixed(2));
  }

  async function closeModalNotificacoes() { setShowNotificacoes(false); }
  async function closeModalSimpleNotificacoes() { setShowNotificacoes(false); }

  const handleOnboardingIniciar = () => {
    const url = onboardingIniciar.url.replace('{empresa_id}', encodeURIComponent(loja));
    requestService(url, { method: onboardingIniciar.method }, history,
      (response: any) => { setOnboardingData(response); setShowWelcomeModal(false); history.push('/empresa/configuracao-inicial'); },
      (error: any) => { console.log('Erro ao iniciar onboarding:', error); setShowWelcomeModal(false); }
    );
  };

  const handleOnboardingFecharModal = () => {
    const url = onboardingIniciar.url.replace('{empresa_id}', encodeURIComponent(loja));
    requestService(url, { method: onboardingIniciar.method }, history,
      (response: any) => { setOnboardingData(response); setShowWelcomeModal(false); },
      (error: any) => { console.log('Erro ao criar registro onboarding:', error); setShowWelcomeModal(false); }
    );
  };

  function isSequencial(pinArray: string[]) {
    if (pinArray.length < 2) return false;
    let isAsc = true; let isDesc = true;
    for (let i = 1; i < pinArray.length; i++) {
      const prev = parseInt(pinArray[i - 1], 10); const curr = parseInt(pinArray[i], 10);
      if (isNaN(prev) || isNaN(curr)) return false;
      if (curr !== prev + 1) isAsc = false;
      if (curr !== prev - 1) isDesc = false;
    }
    return isAsc || isDesc;
  }

  function hasMoreThan3Equal(pinArray: string[]) {
    let count = 1;
    for (let i = 1; i < pinArray.length; i++) {
      if (pinArray[i] === pinArray[i - 1]) { count++; if (count > 3) return true; } else { count = 1; }
    }
    return false;
  }

  const avancarParaConfirmacao = () => {
    if (!pin.every(digit => digit !== '')) { setTextToast("Por favor, preencha todos os 4 dígitos do PIN."); setShowToast(true); return; }
    if (isSequencial(pin)) { setTextToast("O PIN não pode ser sequencial."); setShowToast(true); return; }
    if (hasMoreThan3Equal(pin)) { setTextToast("O PIN não pode ter mais de 3 dígitos iguais em sequência."); setShowToast(true); return; }
    setEtapaPin(2);
    setTimeout(() => { const f = document.getElementById('confirm-pin-input-0'); if (f) (f as HTMLInputElement).focus(); }, 100);
  };

  const salvarPin = async () => {
    if (!confirmPin.every(digit => digit !== '')) { setTextToast("Por favor, preencha todos os 4 dígitos de confirmação."); setShowToast(true); return; }
    const pinString = pin.join(''); const confirmPinString = confirmPin.join('');
    if (pinString !== confirmPinString) {
      setTextToast("Os PINs não conferem. Tente novamente."); setShowToast(true); setErroPin(true); setConfirmPin(['', '', '', '']);
      setTimeout(() => setErroPin(false), 500);
      setTimeout(() => { const f = document.getElementById('confirm-pin-input-0'); if (f) (f as HTMLInputElement).focus(); }, 100);
      return;
    }
    try {
      setShowLoadingPage(true);
      const objeto = { pk: loja, pin: pinString };
      const resp = await fetch(usuariosAlterarPin.url.replace("{pk}", btoa(objeto.pk)), {
        method: usuariosAlterarPin.method,
        headers: [["token", localStorage.getItem("token") || ""]],
        credentials: 'include',
        body: JSON.stringify(objeto)
      });
      if (resp.status === 200) {
        window.localStorage.setItem("pinCadastrado", "true");
        setTextToast("PIN cadastrado com sucesso! Use-o no próximo acesso."); setShowToast(true); setShowModalPin(false);
        if (pendingWelcomeModal) { setPendingWelcomeModal(false); setShowWelcomeModal(true); }
      } else { setTextToast("Erro ao cadastrar PIN. Tente novamente."); setShowToast(true); }
    } catch (error) { setTextToast("Erro ao cadastrar PIN. Tente novamente."); setShowToast(true); }
    finally { setShowLoadingPage(false); }
  };

  const voltarParaCriacao = () => {
    setEtapaPin(1); setConfirmPin(['', '', '', '']);
    setTimeout(() => { const f = document.getElementById('pin-input-0'); if (f) (f as HTMLInputElement).focus(); }, 100);
  };

  useEffect(() => {
    if (isPaymentCompleted && showModalQrCode) { setShowModalQrCode(false); setIsPaymentCompleted(false); }
  }, [isPaymentCompleted]);

  useEffect(() => {
    if (showModalPin) { setTimeout(() => { const f = document.getElementById('pin-validacao-input-0'); if (f) (f as HTMLInputElement).focus(); }, 300); }
  }, [showModalPin]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showModalQrCode) {
      setTimeLeft(6 * 60);
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime > 0) return prevTime - 1;
          clearInterval(timer); handleQrCodeExpired(); return 0;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showModalQrCode]);

  const handleQrCodeExpired = () => {
    setTextToast("Código expirado. Gere um novo para efetuar o pagamento."); setShowToast(true); setShowModalQrCode(false);
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <>
      <Menu id="main-content-inicio"></Menu>
      <IonPage id="main-content-inicio" className="Inicio">
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start"><IonMenuButton /></IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowNotificacoes(true)}>
                <IonIcon slot="icon-only" icon={notifications} />
                <IonBadge id="cart-badge" color="danger">{notificacoes?.length}</IonBadge>
              </IonButton>
            </IonButtons>
            <IonButtons slot="end" hidden={acessos?.chat != 'leitura' && acessos?.chat != 'edicao'}>
              <IonButton onClick={() => history.push("./chat")}>
                <IonIcon slot="icon-only" icon={chatbubbles} />
                <IonBadge id="cart-badge" color="danger">{mensagens?.length}</IonBadge>
              </IonButton>
            </IonButtons>
          </IonToolbar>

          {dadosEmpresa && Object.keys(dadosEmpresa).length > 0 && (
            <IonToolbar color="light" hidden={dadosEmpresa.tempoRestanteParaPagamento > 20 || dadosEmpresa.pk != dadosEmpresa.gsi3pk}>
              <IonGrid>
                <IonRow class="ion-align-items-center">
                  <IonCol size="auto">
                    <IonLabel>
                      <strong>
                        {dadosEmpresa.bloquearAcesso
                          ? "Seu acesso foi bloqueado. Realize o pagamento para continuar utilizando nossos serviços."
                          : (dadosEmpresa.tempoRestanteParaPagamento || 0) === 0
                            ? "Sua licença vence hoje. Realize o pagamento para manter o acesso."
                            : dadosEmpresa.tempoRestanteParaPagamento === 1
                              ? "Falta 1 dia para o vencimento da sua licença. Realize o pagamento para manter o acesso."
                              : `Faltam ${dadosEmpresa.tempoRestanteParaPagamento || 0} dias para o vencimento da sua licença. ${dadosEmpresa.tempoRestanteParaPagamento <= 10 ? "Realize o pagamento para manter o acesso." : "Garanta o próximo mês."}`
                        }
                      </strong>
                    </IonLabel>
                  </IonCol>
                  <IonCol class="ion-text-right">
                    <IonButton color="danger" size="small" onClick={abrirPlanosPagamento}>
                      Realizar Pagamento
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonToolbar>
          )}
        </IonHeader>

        <IonContent fullscreen={false}>

          {/* ── Container único centralizado — banner + cards + swiper ── */}
          <div className="inicio-content-wrapper">
            <div className="inicio-inner">

              {/* Banner de onboarding */}
              {onboardingData && !onboardingData.onboarding_concluido && (
                <OnboardingHomeBanner
                  porcentagem={onboardingData.porcentagem}
                  totalEtapas={onboardingData.total_etapas}
                  etapasConcluidas={onboardingData.etapas.filter((e: any) => e.status === 'concluido').length}
                  onClick={() => history.push('/empresa/configuracao-inicial')}
                />
              )}

              {/* Grid de cards */}
              <div id="containerInicioCategorias">
                <IonGrid>
                  <IonRow>
                    <IonCol size="6" hidden={acessos?.vendas != 'leitura' && acessos?.vendas != 'edicao'}>
                      <IonCard onClick={() => history.push("./vendas")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={trendingUpOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Vendas</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>Funil de vendas e orçamentos</IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6" hidden={acessos?.totem != 'leitura' && acessos?.totem != 'edicao'}>
                      <IonCard onClick={() => history.push("./totem")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={tabletPortraitSharp} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Totem</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>Autoatendimento</IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6" hidden={acessos?.balcao != 'leitura' && acessos?.balcao != 'edicao'}>
                      <IonCard onClick={() => history.push("./caixa")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={desktopOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Balcão</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>PDV</IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6" hidden={acessos?.comandas != 'leitura' && acessos?.comandas != 'edicao'}>
                      <IonCard onClick={() => history.push("./comandas")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={clipboardOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>{window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas"}</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>
                          Efetue {window.localStorage.getItem("servicoTipo") || "Projeto"} diretamente nas {window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas"}
                        </IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6" hidden={acessos?.projetos != 'leitura' && acessos?.projetos != 'edicao'}>
                      <IonCard onClick={() => history.push("./ordens")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={appsOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>{window.localStorage.getItem("servicoTipoPlural") || "Projetos"}</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>Crie e acompanhe {window.localStorage.getItem("servicoTipoPlural") || "Projetos"}</IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6" hidden={acessos?.agenda != 'leitura' && acessos?.agenda != 'edicao'}>
                      <IonCard onClick={() => history.push("./agendamentoseventoscommenu")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={calendarOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Agenda</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>Agende entregas, serviços e reuniões</IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6" hidden={acessos?.operacoes != 'leitura' && acessos?.operacoes != 'edicao'}>
                      <IonCard onClick={() => history.push("./operacoes")} style={{ height: "134px", cursor: 'pointer' }} disabled={dadosEmpresa.bloquearAcesso}>
                        <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                          <IonIcon color='primary' style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }} icon={flagOutline} />
                          <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Operações</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent style={{ fontSize: "12px" }}>Acompanhe o dia a dia da equipe</IonCardContent>
                      </IonCard>
                    </IonCol>

                    <IonCol size="6">
                      <a target='_blank' rel="noreferrer" href="https://api.whatsapp.com/send?phone=5511963927646" style={{ textDecoration: 'none' }}>
                        <IonCard className="card-ajuda-destaque" style={{ height: "134px", cursor: 'pointer' }}>
                          <IonBadge color="success" className="card-ajuda-destaque-badge">Fale conosco</IonBadge>
                          <IonCardHeader style={{ paddingTop: '14px', paddingBottom: '0px' }}>
                            <IonIcon color="success" style={{ border: '1px solid #ccc', borderRadius: '10px', padding: '10px' }}  icon={chatbubblesOutline} />
                            <IonCardTitle style={{ fontSize: "16px", fontWeight: 'bold' }}>Suporte</IonCardTitle>
                          </IonCardHeader>
                          <IonCardContent style={{ fontSize: "12px" }}>Como podemos ajudar você?</IonCardContent>
                        </IonCard>
                      </a>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>

              {/* Swiper de banners */}
              <div className="inicio-swiper-container">
                <Swiper
                  spaceBetween={0}
                  centeredSlides={true}
                  autoplay={{ delay: 5000, disableOnInteraction: false }}
                  pagination={{ clickable: true }}
                  navigation={false}
                  modules={[Autoplay, Pagination, Navigation]}
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                >
                  <SwiperSlide>
                    <img src="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/banners/banner1.png" alt="Banner 1" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/banners/banner2.png" alt="Banner 2" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/banners/banner3.png" alt="Banner 3" />
                  </SwiperSlide>
                </Swiper>
              </div>

            </div>
          </div>

          {/* Onboarding Welcome Modal */}
          <WelcomeModal isOpen={showWelcomeModal} onClose={handleOnboardingFecharModal} onStart={handleOnboardingIniciar} />

          <div className="content">
            {/* Aviso de vencimento próximo ou em atraso */}
            <IonModal
              className="aviso-pagamento-modal"
              isOpen={showModalAvisoPagamento && !showModalPin && !showWelcomeModal}
              backdropDismiss={false}
              onDidDismiss={() => setShowModalAvisoPagamento(false)}
            >
              <IonContent className="ion-padding">
                <div className="aviso-pagamento-conteudo">
                  <div className="aviso-pagamento-icone" aria-hidden="true">
                    <IonIcon icon={warningOutline} />
                  </div>
                  <h2>{diasRestantesPagamento < 0 ? "Seu pagamento está vencido" : "Seu pagamento está próximo do vencimento"}</h2>
                  <p className="aviso-pagamento-prazo">
                    {diasRestantesPagamento < 0
                      ? Math.abs(diasRestantesPagamento) === 1
                        ? "Sua licença venceu há 1 dia."
                        : `Sua licença venceu há ${Math.abs(diasRestantesPagamento)} dias.`
                      : diasRestantesPagamento === 0
                        ? "Sua licença vence hoje."
                        : diasRestantesPagamento === 1
                          ? "Falta 1 dia para o vencimento da sua licença."
                          : `Faltam ${diasRestantesPagamento} dias para o vencimento da sua licença.`}
                  </p>
                  <p>
                    {dadosEmpresa.bloquearAcesso
                      ? "Realize o pagamento para recuperar seu acesso aos recursos do Xeguei."
                      : "Realize o pagamento para não ficar sem acesso aos recursos do Xeguei."}
                  </p>
                  <div className="aviso-pagamento-acoes">
                    <IonButton fill="outline" color="medium" onClick={() => setShowModalAvisoPagamento(false)}>
                      Fechar
                    </IonButton>
                    <IonButton color="danger" onClick={abrirPlanosPagamento}>
                      Realizar pagamento
                    </IonButton>
                  </div>
                </div>
              </IonContent>
            </IonModal>

            {/* Modal PIN */}
            <IonModal isOpen={showModalPin} backdropDismiss={false} onDidDismiss={() => setShowModalPin(false)}>
              <IonHeader className="ion-no-border">
                <IonToolbar>
                  {etapaPin === 2 && (
                    <IonButtons slot="start">
                      <IonButton onClick={voltarParaCriacao}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
                    </IonButtons>
                  )}
                  <IonTitle>{etapaPin === 1 ? "Criar PIN de Acesso" : "Confirmar PIN"}</IonTitle>
                </IonToolbar>
              </IonHeader>
              <IonContent className="ion-padding">
                <IonGrid>
                  <IonRow className="ion-justify-content-center ion-margin-top">
                    <IonCol size="12" sizeMd="8" sizeLg="6">
                      <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <IonIcon icon={lockClosedOutline} style={{ fontSize: "40px", color: "var(--ion-color-primary)" }} />
                      </div>
                      {etapaPin === 1 && (
                        <>
                          <IonLabel>
                            <h2 style={{ textAlign: "center", marginBottom: "10px" }}><strong>Configure seu PIN</strong></h2>
                            <p style={{ textAlign: "center", color: "var(--ion-color-medium)", marginBottom: "20px" }}>
                              Crie um PIN de 4 dígitos para facilitar seu próximo acesso ao sistema.
                            </p>
                          </IonLabel>
                          <PINInput length={4}
                            onChange={(v: any) => { const a = v.split(""); while (a.length < 4) a.push(""); setPin(a.slice(0, 4)); }}
                            onComplete={(v: any) => setPin(v.split(""))}
                          />
                          <IonButton expand="block" onClick={() => { if (!pin.every(d => d !== '')) { setTextToast("Por favor, preencha todos os 4 dígitos do PIN."); setShowToast(true); return; } avancarParaConfirmacao(); }} style={{ marginTop: '20px' }}>
                            Avançar
                          </IonButton>
                        </>
                      )}
                      {etapaPin === 2 && (
                        <>
                          <IonLabel>
                            <h2 style={{ textAlign: "center", marginBottom: "10px" }}><strong>Confirme seu PIN</strong></h2>
                            <p style={{ textAlign: "center", color: "var(--ion-color-medium)", marginBottom: "20px" }}>
                              Digite novamente o PIN para confirmar.
                            </p>
                          </IonLabel>
                          <PINInput length={4} error={erroPin}
                            onChange={(v: any) => { const a = v.split(""); while (a.length < 4) a.push(""); setConfirmPin(a.slice(0, 4)); }}
                            onComplete={(v: any) => setConfirmPin(v.split(""))}
                          />
                          <IonButton expand="block" onClick={() => { if (!confirmPin.every(d => d !== '')) { setTextToast("Por favor, preencha todos os 4 dígitos de confirmação."); setShowToast(true); return; } salvarPin(); }} style={{ marginTop: '20px' }}>
                            Salvar
                          </IonButton>
                        </>
                      )}
                      <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#f0f9ff", borderRadius: "10px", border: "1px solid #bfdbfe" }}>
                        <IonLabel>
                          <p style={{ fontSize: "12px", color: "var(--ion-color-medium)", margin: 0 }}>
                            <strong>💡 Dica:</strong> Escolha um PIN fácil de lembrar. Ele será usado para acessos rápidos ao sistema.
                          </p>
                        </IonLabel>
                      </div>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonContent>
            </IonModal>

            {/* Modal Planos */}
            <IonModal className="fullscreen-modal" isOpen={showModalPlanos} onDidDismiss={() => setShowModalPlanos(false)}>
              <IonHeader className="ion-no-border">
                <IonToolbar>
                  <IonButtons slot="start">
                    <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalPlanos(false)} />
                  </IonButtons>
                  <IonTitle>Monte seu plano</IonTitle>
                </IonToolbar>
              </IonHeader>
              <IonContent className="ion-padding">
                {loadingPlanos ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <IonLoading isOpen={loadingPlanos} message="Carregando planos..." />
                  </div>
                ) : planoBase ? (
                  <IonGrid style={{ padding: '0px' }}>
                    <IonRow style={{ alignItems: 'stretch' }}>
                      <IonCol size="12" sizeMd={modulosDisponiveis && modulosDisponiveis.length > 0 ? "6" : "12"} style={{ display: 'flex', flexDirection: 'column' }}>
                        <IonCard style={{ border: '2px solid var(--ion-color-primary)', position: 'relative', flex: 1, display: 'flex', flexDirection: 'column', margin: '4px' }}>
                          <div style={{ position: 'absolute', top: '12px', right: '12px', backgroundColor: 'var(--ion-color-primary)', color: '#fff', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', zIndex: 10 }}>Plano Base</div>
                          <IonCardHeader style={{ flex: '0 0 auto', paddingRight: '110px' }}>
                            <IonCardTitle>{planoBase.titulo}</IonCardTitle>
                            {planoBase.subtitulo && <p style={{ fontSize: '14px', color: 'var(--ion-color-medium)', marginTop: '2px', marginBottom: '12px' }}>{planoBase.subtitulo}</p>}
                            <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '4px', marginTop: '4px' }}>{planoBase.valorFormatado}<span style={{ fontSize: '16px', fontWeight: 'normal' }}> /mês</span></p>
                            {planoBase.percentualDesconto > 0
                              ? <p style={{ fontSize: '14px', color: 'var(--ion-color-success)', marginBottom: '0px', fontWeight: 'bold' }}>Desconto de {planoBase.percentualDescontoFormatado} aplicado!</p>
                              : <p style={{ fontSize: '14px', color: 'var(--ion-color-medium)' }}>Quer pagar menos? Garanta seu desconto{' '}<a href="#" onClick={(e) => { e.preventDefault(); window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Gostaria de obter meu desconto na mensalidade do xeguei", "_blank"); }} style={{ color: 'var(--ion-color-success)', textDecoration: 'underline' }}>aqui!</a></p>
                            }
                          </IonCardHeader>
                          <IonCardContent style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                            <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
                              {planoBase.recursos && planoBase.recursos.map((r: string, i: number) => <li key={i} style={{ marginBottom: '4px' }}>{r}</li>)}
                            </ul>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      {modulosDisponiveis && modulosDisponiveis.length > 0 && (
                        <IonCol size="12" sizeMd="6" style={{ display: 'flex', flexDirection: 'column' }}>
                          {modulosDisponiveis.map((modulo: any) => {
                            const selecionado = modulosSelecionados.includes(modulo.id);
                            return (
                              <IonCard key={modulo.id} style={{ border: selecionado ? '2px solid var(--ion-color-primary)' : '1px solid #ddd', position: 'relative', flex: 1, display: 'flex', flexDirection: 'column', margin: '4px' }}>
                                {modulo.recomendado && <div style={{ position: 'absolute', top: '12px', right: '12px', backgroundColor: 'var(--ion-color-primary)', color: '#fff', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', zIndex: 10 }}>Recomendado</div>}
                                <IonCardHeader style={{ flex: '0 0 auto', paddingRight: modulo.recomendado ? '120px' : undefined }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <IonCheckbox checked={selecionado} onIonChange={(e) => { e.stopPropagation(); setModulosSelecionados(prev => e.detail.checked ? [...prev, modulo.id] : prev.filter(id => id !== modulo.id)); }} />
                                    <IonCardTitle style={{ fontSize: '18px' }}>{modulo.titulo}</IonCardTitle>
                                  </div>
                                  <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '8px 0 0' }}>+ {modulo.valorFormatado}<span style={{ fontSize: '14px', fontWeight: 'normal' }}> /mês</span></p>
                                </IonCardHeader>
                                <IonCardContent style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                  <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
                                    {modulo.recursos && modulo.recursos.map((r: string, i: number) => <li key={i} style={{ marginBottom: '4px' }}>{r}</li>)}
                                  </ul>
                                </IonCardContent>
                              </IonCard>
                            );
                          })}
                        </IonCol>
                      )}
                    </IonRow>
                  </IonGrid>
                ) : (
                  <IonGrid>
                    <IonRow>
                      {planos.map((plano: any) => (
                        <IonCol key={plano.id} size="12" sizeMd="4">
                          <IonCard style={{ ...(plano.destaque ? { border: '2px solid var(--ion-color-primary)' } : {}), position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
                            {plano.destaque && <div style={{ position: 'absolute', top: '12px', right: '12px', backgroundColor: 'var(--ion-color-primary)', color: '#fff', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', zIndex: 10 }}>Recomendado</div>}
                            <IonCardHeader style={{ flex: '0 0 auto' }}>
                              <IonCardTitle style={{ paddingRight: plano.destaque ? '110px' : '0' }}>{plano.titulo}</IonCardTitle>
                              {plano.subtitulo && <p style={{ fontSize: '14px', color: 'var(--ion-color-medium)', marginTop: '2px', marginBottom: '12px' }}>{plano.subtitulo}</p>}
                              {plano.valorFormatado && <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '4px', marginTop: '4px' }}>{plano.valorFormatado}{plano.recorrencia && <span style={{ fontSize: '16px', fontWeight: 'normal' }}> /{plano.recorrencia}</span>}</p>}
                            </IonCardHeader>
                            <IonCardContent style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                              <div style={{ flex: '1' }}>
                                {plano.descricao && <p style={{ marginBottom: '12px' }}>{plano.descricao}</p>}
                                {plano.recursos && plano.recursos.length > 0 && <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>{plano.recursos.map((r: string, i: number) => <li key={i} style={{ marginBottom: '4px' }}>{r}</li>)}</ul>}
                              </div>
                              <div style={{ marginTop: 'auto' }}>
                                <IonButton expand="block" color={plano.destaque ? "primary" : "secondary"} style={{ marginTop: '20px' }} onClick={async () => {
                                  if (plano.contemContato) { window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Olá! Gostaria de saber mais sobre o plano Multi Lojas.", "_blank"); return; }
                                  var token = localStorage.getItem("token") || "";
                                  const objectRequest = plano.tipo ? { compra: plano.tipo } : undefined;
                                  let resp = await fetch(pagamentoMensalidade.url.replace("{id}", loja.replaceAll(/#/g, "%23")), { method: pagamentoMensalidade.method, headers: [["token", token]], body: objectRequest ? JSON.stringify(objectRequest) : undefined, credentials: 'include' });
                                  let retorno = await resp.json();
                                  if (resp.status === 400 || resp.status === 401) { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                                  else if (retorno.message) { setIdPagamento(retorno.message.id); setQRCode(retorno.message.point_of_interaction.transaction_data.qr_code); setQRCodeData(retorno.message.point_of_interaction.transaction_data.qr_code_base64); setValorPagamento(retorno.message.transaction_amount); setShowModalPlanos(false); setShowModalQrCode(true); }
                                  else { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                                }}>{plano.contemContato ? 'Falar com especialista' : 'Selecionar'}</IonButton>
                              </div>
                            </IonCardContent>
                          </IonCard>
                        </IonCol>
                      ))}
                    </IonRow>
                  </IonGrid>
                )}
              </IonContent>
              {planoBase && (
                <IonFooter>
                  <IonToolbar style={{ '--background': 'var(--ion-color-light)', padding: '8px', paddingBottom: '4px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', paddingLeft: '12px', paddingRight: '12px' }}>
                      <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Total mensal:</span>
                      <span style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--ion-color-primary)' }}>R$ {calcularTotalDinamico(modulosSelecionados).toFixed(2).replace('.', ',')}</span>
                    </div>
                    {dadosEmpresaPlanos && dadosEmpresaPlanos.quantidadeLojas > 1 && (
                      <p style={{ fontSize: '13px', color: 'var(--ion-color-medium)', marginBottom: '8px', paddingLeft: '12px', paddingRight: '12px' }}>Valor referente a {dadosEmpresaPlanos.quantidadeLojas} lojas.</p>
                    )}
                    <IonButton size="large" expand="block" color="primary" onClick={async () => {
                      var token = localStorage.getItem("token") || "";
                      const compraCanonica = gerarCompraCanonica(modulosSelecionados);
                      const quantLojas = (dadosEmpresaPlanos && dadosEmpresaPlanos.quantidadeLojas) || 1;
                      const objectRequest = { compra: compraCanonica, modulos: modulosSelecionados, quantidadeLojas: quantLojas, metodoPagamento: "pix" };
                      let resp = await fetch(pagamentoMensalidade.url.replace("{id}", loja.replaceAll(/#/g, "%23")), { method: pagamentoMensalidade.method, headers: [["token", token]], body: JSON.stringify(objectRequest), credentials: 'include' });
                      let retorno = await resp.json();
                      if (resp.status === 400 || resp.status === 401) { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                      else if (retorno.message) { setIdPagamento(retorno.message.id); setQRCode(retorno.message.point_of_interaction.transaction_data.qr_code); setQRCodeData(retorno.message.point_of_interaction.transaction_data.qr_code_base64); setValorPagamento(retorno.message.transaction_amount); setShowModalPlanos(false); setShowModalQrCode(true); }
                      else { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                    }}>Pagar via Pix</IonButton>
                  </IonToolbar>
                </IonFooter>
              )}
            </IonModal>

            {/* Modal QR Code */}
            <IonModal className="fullscreen-modal" isOpen={showModalQrCode} onDidDismiss={() => { setShowModalQrCode(false); setIdPagamento(""); }}>
              <IonHeader className="ion-no-border">
                <IonToolbar>
                  <IonButtons slot="start">
                    <IonIcon slot="icon-only" icon={arrowBack} onClick={() => { setShowModalQrCode(false); setShowModalPlanos(true); setIdPagamento(""); }} />
                  </IonButtons>
                  <IonTitle>Detalhes do pagamento</IonTitle>
                </IonToolbar>
              </IonHeader>
              <IonContent>
                <IonCard className="div-qrcode-pagamento">
                  <IonCardContent>
                    <IonLabel className="qr-code-pagamento"><h2><b>Assinatura XEGUEI</b></h2></IonLabel>
                    <IonLabel><p className="payment-title">Pague <b>R$ {valorPagamento?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> via <b>Pix</b></p></IonLabel>
                    <IonLabel className="qr-code-pagamento-margin"><h3>Para pagar, escolha uma destas opções:</h3></IonLabel>
                    <IonCardContent className="qr-code-pagamento">
                      <IonLabel><p>Código QR</p></IonLabel>
                      {qrCodeData && <img src={`data:image/png;base64,${qrCodeData}`} alt="QR Code" />}
                    </IonCardContent>
                    <IonCardContent className="qr-code-pagamento">
                      <IonLabel><p>Código de pagamento</p></IonLabel>
                      <div className="copy-code-container">
                        <IonTextarea readonly={true} style={{ "--background": "#eeeeee" }} rows={2} value={qrCode} />
                        <IonButton fill="clear" onClick={() => { navigator.clipboard.writeText(qrCode); setTextToast("Código copiado"); setShowToast(true); }}>
                          <IonIcon color="primary" icon={copy} />
                        </IonButton>
                      </div>
                    </IonCardContent>
                    <IonLabel className="qr-code-pagamento">Código válido por: <h1>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1></IonLabel>
                    <IonCardContent>
                      <IonLabel>
                        <p><b>Como pagar?</b></p>
                        <ol>
                          <li>Entre no app ou site do seu banco e escolha a opção de pagamento via Pix.</li>
                          <li>Escaneie o código QR ou copie e cole o código de pagamento.</li>
                          <li>Pronto! Agora é só aguardar o pagamento ser processado.</li>
                        </ol>
                      </IonLabel>
                    </IonCardContent>
                  </IonCardContent>
                </IonCard>
              </IonContent>
            </IonModal>

            <IonModal isOpen={showNotificacoes} onDidDismiss={() => setShowNotificacoes(false)}>
              <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes} />
            </IonModal>
          </div>

          <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
          <IonLoading cssClass='my-custom-class' isOpen={showLoadingPage} onDidDismiss={() => setShowLoadingPage(false)} spinner='circles' />
        </IonContent>
      </IonPage>
    </>
  );
};

export default Inicio;
